/**
 * 系统级错误定义
 */
export default {
  'timeout': '响应超时，请稍候再试',
  'Network Error': '网络连接不可用，请联系管理员设置网络',
  '500': '服务器异常，请稍候再试',
}